import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';

interface InputProps {
	isError: boolean;
	value: string;
}

const Wrapper = styled('div')`
	flex: 0 1 500px;
	margin-left: 20px;
	margin-right: auto;

	@media only screen and (min-width: 1024px) {
		margin-left: 97px;
	}
`;

const Input = styled('input')`
	box-sizing: border-box;
	width: 100%;
	padding: 5px;
	border: 1px solid ${NewStyleColor.Grey950};
	outline: 0;
	border-radius: 4px;
	background-color: ${NewStyleColor.Grey950};
	font-size: 15px;
	line-height: 18px;
	color: ${NewStyleColor.White};
	-webkit-appearance: none;

	${(props: InputProps) => (props.isError || !props.value) && `border-color: ${NewStyleColor.Red100};`}

	&:focus {
		border-color: ${(props: InputProps) => (props.isError || !props.value)
			? `${NewStyleColor.Red100}`
			: `${NewStyleColor.White}`
		};
	}

	::-ms-clear {
		display: none;
	}
`;

export {
	Wrapper,
	Input,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Title/styles.ts